import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
import { BrainIcon, ZapIcon, RefreshCwIcon } from 'lucide-react';
const solutions = [{
  icon: <BrainIcon className="w-7 h-7 text-accent-gold mb-2 mx-auto" data-id="element-180" />,
  title: 'ENTENDÉS QUÉ PASA',
  desc: 'Dejás de tenerle miedo al miedo. Cuando entendés la neurociencia detrás del pánico, el 50% del problema desaparece solo.'
}, {
  icon: <ZapIcon className="w-7 h-7 text-accent-gold mb-2 mx-auto" data-id="element-181" />,
  title: 'ACTUÁS EN EL MOMENTO',
  desc: 'Protocolos de 30 a 90 segundos para frenar un ataque donde estés — sin que nadie se dé cuenta.'
}, {
  icon: <RefreshCwIcon className="w-7 h-7 text-accent-gold mb-2 mx-auto" data-id="element-182" />,
  title: 'CAMBIÁS EL PATRÓN DE FONDO',
  desc: 'TCC, ACT y biohacking nervioso para que la ansiedad deje de volver una y otra vez.'
}];
export function SolutionSection() {
  const {
    ref,
    isInView
  } = useInView();
  return <section className="py-4 px-4 bg-primary" ref={ref} data-id="element-183">
      <div className="max-w-6xl mx-auto" data-id="element-184">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.5
      }} className="text-center mb-3" data-id="element-185">
          <h2 className="text-xl sm:text-2xl font-bold text-white mb-1" data-id="element-186">
            La solución definitiva
          </h2>
          <p className="text-text-secondary text-sm sm:text-base" data-id="element-187">
            Un sistema completo que ataca la ansiedad desde todas las capas a la
            vez
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-2" data-id="element-188">
          {solutions.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 30
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-card border-t-3 border-accent-gold rounded-md py-3 px-3 text-center hover:-translate-y-1 transition-transform duration-300" data-id="element-189">
              {item.icon}
              <h3 className="text-white font-bold text-sm mb-1" data-id="element-190">
                {item.title}
              </h3>
              <p className="text-text-secondary text-xs leading-snug" data-id="element-191">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}